<div class="content_wrap_section">
    <div class="wrap_header_sectons">
        <div class="top_header_overlay"></div>
        <h1>採用情報</h1>
    </div>

    <div class="about_us_wrap">
        <div class="container">
            <div class="row">
                <div class="con-md-12">
                    <div class="about_us_right_contents padding_left_side work_with_us_contents">
                        <h3>新たな可能性を探り続ける</h3>
                        <p>私たちは、常に挑戦を続け、技術の革新を目指す約20人のチームです。自然言語処理およびAI技術による自動校閲の分野で、これまでにいくつもの発明をしてきましたが、今後もさらなる挑戦を続けていきます。現在私たちは <a href="https://www.crimsoni.ai/work-with-us.htm" target="_blank">共に挑戦をしてくれる新たな仲間を募集</a>しています。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>